import React from 'react';
import { useTranslation } from 'react-i18next';

interface ItemCountPillProps {
  count: number;
  className?: string;
}

const ItemCountPill: React.FC<ItemCountPillProps> = ({ count, className }) => {
  const { t } = useTranslation();

  return (
    <span className={`checkout-header__pill${className ? ` ${className}` : ''}`}>
      {t('pages.checkout.step1.items_count', { count })}
    </span>
  );
};

export default ItemCountPill;
